import { withAsyncPaginate } from 'react-select-async-paginate';
import UiSelect from '../UiSelect/UiSelect';

const CustomAsyncPaginate = withAsyncPaginate(UiSelect as any);

export { CustomAsyncPaginate };
